import { useState, useEffect } from 'react';
import { fetchStationDetails, generateStreamUrls, fetchAndSetStreamUrl } from '../services/stationService';

export const useStationConfig = () => {
    const [urls, setUrls] = useState({
        streamUrl: '',
        apiUrl: ''
    });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [notification, setNotification] = useState({
        isOpen: false,
        title: '',
        message: ''
    });

    useEffect(() => {
        const configureStation = async () => {
            try {
                // Get station ID from URL
                const params = new URLSearchParams(window.location.search);
                const stationId = params.get('id');

                if (!stationId) {
                    setIsLoading(false);
                    return;
                }

                // Fetch station details
                const stationDetails = await fetchStationDetails(stationId);

                // Generate URLs
                const generatedUrls = generateStreamUrls(stationDetails);

                // Fetch stream URL
                const streamUrl = await fetchAndSetStreamUrl(generatedUrls.apiUrl);

                // Update URLs
                setUrls({
                    apiUrl: generatedUrls.apiUrl,
                    streamUrl: streamUrl
                });
            } catch (err) {
                console.error('Failed to configure station:', err);
                setError(err.message || 'Failed to configure station');
                setNotification({
                    isOpen: true,
                    title: 'Configuration Error',
                    message: 'We couldn\'t fetch your station details. Please try again later or contact support if the problem persists.'
                });
            } finally {
                setIsLoading(false);
            }
        };

        configureStation();
    }, []);

    const closeNotification = () => {
        setNotification(prev => ({ ...prev, isOpen: false }));
    };

    const contactSupport = () => {
        window.open('https://radiolize.com/contact-us/', '_blank');
    };

    return {
        urls,
        setUrls,
        error,
        isLoading,
        notification,
        closeNotification,
        contactSupport
    };
}; 